import React from "react";
import styled from "styled-components";

const ProjectStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 60%;
    cursor: pointer;
    background-color: transparent;
    transition: 0.3s;
    &:hover {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        background-color: #282c34;
        border-radius: 10px;
        transform: scale(1.05);
        padding: 20px;
    }
    max-width: 15vw;

    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
`;

const ProjectPhoto = styled.img`
    border-radius: 50%;
    width: 15vmin;
    height: 15vmin;
    object-fit: cover;
    ${ProjectStyled}:hover & {
        border-radius: 10px;
        object-fit: default;
        width: 10vmin;
        height: 10vmin;
    }
    min-width: 100px;
    min-height: 100px;
`;

const ProjectName = styled.h1`
    font-size: 120%;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
    text-align: center;
    display: none;
    ${ProjectStyled}:hover & {
        display: block;
    }
`;

// description should be shown when hovering over the project
const ProjectDescription = styled.p`
    text-align: center;
    display: none;
    ${ProjectStyled}:hover & {
        display: block;
    }
`;

class Project extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.name,
      description: props.description,
      photo: props.photo,
      link: props.link,
    };
  }

  render() {
        return (
            <ProjectStyled onClick={() => window.open(this.state.link)}>
                <ProjectPhoto src={this.state.photo} />
                <ProjectName>{this.state.name}</ProjectName>
                <ProjectDescription>{this.state.description}</ProjectDescription>
            </ProjectStyled>
        );
    }
}

export default Project;
